// Нарастающая пауза поллинга, пока наш API недоступен. Без неё виджет при
// лежащем сервере продолжает опрашивать /messages по обычному кадансу: страницу
// клиента это не блокирует, но в консоли копятся ошибки, а на мобильном это
// лишний расход батареи и трафика — «ваш скрипт долбит сеть» глазами
// корпоративного клиента. Чистый модуль (DOM нет) — тестируется в изоляции
// (backoff.test.mjs), как delay.ts и timers.ts.

/** Потолок паузы: 2 минуты. Выше нельзя — после оживления сервера пассивная
 *  вкладка узнаёт об этом только следующим опросом, и потолок задаёт худшую
 *  задержку возврата в строй. Активному гостю ждать не приходится: кнопка
 *  «Повторить» на баннере и отправка реплики опрашивают сразу. */
const BACKOFF_CAP_MS = 120_000;

/** Пауза до следующего опроса с учётом подряд идущих неудач.
 *
 *  Первая неудача держит обычный каданс: одиночный обрыв на мобильной сети —
 *  норма, замедляться из-за него нельзя (гость, может быть, ждёт ответ). Со
 *  второй подряд пауза удваивается от обычной до потолка; первый успех обязан
 *  сбросить счётчик у вызывающего.
 *
 *  @param normal обычная пауза текущего режима (ждём ответ / открыт / фон), мс.
 *  @param failures число НЕУДАЧ ПОДРЯД к этому моменту.
 *  @return пауза в мс; мусор в failures (NaN, отрицательное) читается как 0. */
export function backoffDelayMs(normal: number, failures: number): number {
  if (!(failures >= 1)) return normal;
  return Math.min(BACKOFF_CAP_MS, normal * 2 ** (failures - 1));
}
